/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_S3Inputs */

const en_tut_inbox_s3 = /** @type {(inputs: Tut_Inbox_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click a row to open its source — issue, message, or meeting — at exactly the right place.`)
};

const id_tut_inbox_s3 = /** @type {(inputs: Tut_Inbox_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik satu baris untuk membuka sumbernya — issue, pesan, atau rapat — tepat pada bagian yang dimaksud.`)
};

/**
* | output |
* | --- |
* | "Click a row to open its source — issue, message, or meeting — at exactly the right place." |
*
* @param {Tut_Inbox_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_s3 = /** @type {((inputs?: Tut_Inbox_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_s3(inputs)
	return en_tut_inbox_s3(inputs)
});